export default {"src":"/fly/_next/static/media/cl.b08e0304.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};